module.exports = __webpack_public_path__ + "static/img/icon49.08d5b47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon49.png
// module id = TC6u
// module chunks = 0